import React from 'react';
import { View } from 'react-native';
import { colors } from "../../../theming/themes/alucio/colors";
import util from '../../util';
export var StatusType;
(function (StatusType) {
    StatusType["success"] = "success";
    StatusType["warning"] = "warning";
    StatusType["error"] = "error";
    // WHITE
    StatusType["info"] = "info";
    StatusType["tag"] = "tag";
})(StatusType || (StatusType = {}));
const colorMap = {
    [StatusType.success]: 'ui2-success-500',
    [StatusType.warning]: 'ui2-warning-500',
    [StatusType.error]: 'ui2-danger-500',
    [StatusType.info]: 'white',
    [StatusType.tag]: 'white',
};
const S = {
    Circle: (status) => ({
        height: 8,
        width: 8,
        borderRadius: 8 / 2,
        backgroundColor: colors[colorMap[status]],
        marginTop: 1,
    }),
};
const StatusBullet = (props) => {
    const { status } = props;
    return (<View style={util.mergeStyles(undefined, S.Circle(status), [{ borderWidth: 3, height: 12, width: 12, borderRadius: 12 / 2 }, (props.mode === 'grid')])}/>);
};
export default StatusBullet;
//# sourceMappingURL=StatusBullet.js.map